// extracted by mini-css-extract-plugin
module.exports = {"social-link__img":"SocialLink_social-link__img__17PYU","social-link--wide":"SocialLink_social-link--wide__1UnVu"};